export const RequestStrategyEnum = {
  Default: 'default',
  Debounce: 'debounce',
  Abort: 'abort',
} as const;
export type RequestStrategyEnum = (typeof RequestStrategyEnum)[keyof typeof RequestStrategyEnum];
